import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import cn from "classnames";
import AccessControl from "../../../HOC/AccessControl";
import styles from "./Released.module.sass";
import Card from "../../../components/Card";
import Form from "../../../components/Form";
import Icon from "../../../components/Icon";
import OrdersTable from "./OrdersTable";
import { Divider, Tooltip } from "antd";
import AssignToPickerOrPacker from "./Filters/AssignToPickerOrPacker";
import Export from "./Filters/Export";
import Filter from "./Filters/IndexFilter";
import useDarkMode from "use-dark-mode";
import {
  GET_FETCH_TAG_SUGGESTION,
  GET_ORDER_FILTER_OPTIONS_BY_TYPE,
  GET_ALL_CUSTOM_FILTERS,
  order_details,
  EXPORT_MULTIPLE_ORDER_MEDIA,
} from "../../../API/Orders";
import { SEND_SELECTED_EMPLOYEE_ID } from "../../../API/Employee";
import CustomizingOrderFields from "./Filters/CustomizingOrderFields";
import AllFiltersDropdown from "./Filters/AllFilersDropdown";
import Swal from "sweetalert2";
import CustomToast from "../../../components/CustomToast";
import { get_store_sync_status } from "../../../API/Store";
import GeneratePickListPopUp from "./Modals/GeneratePicklist/GeneratePickList";
import Loader from "../../../components/Loader";
import MultiAccessControl from "../../../HOC/MultiAccessControl";
import CustomAlert from "../../../components/CustomAlert";
import Dropdown from "./Dropdown/Index";
import { getStartAndEndDate } from "../../../utils/dateUtils";
import { debounce } from "../../../utils/utilities";
import LoaderOverlay from "./LoadingOverlay/LoadingOverlay";

const AllOrders = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [assignvisibleModal, setAssignVisibleModal] = useState(false);
  const [picklistvisibleModal, setPicklistVisibleModal] = useState(false);
  const [visibleModal, setVisibleModal] = useState(false);
  const [search, setSearch] = useState("");
  const [searchVisible, setSearchVisible] = useState(false);
  const [iconVisible, setIconVisible] = useState(true);
  const [newButtonName, setNewButtonName] = useState("");
  const [buttons, setButtons] = useState([]);
  const [syncStatus, setSyncStatus] = useState();
  const darkMode = useDarkMode(false);
  const [activeFilterId, setActiveFilterId] = useState(null);
  const [selectedFilters, setSelectedFilters] = useState({});
  const [isNewFilterModalOpen, setIsNewFilterModalOpen] = useState(false);
  const [activeFilter, setActiveFilter] = useState(null);
  const [returnedOrders, setReturnedOrders] = useState(false);
  const [isReturnActive, setIsReturnActive] = useState(false);
  const [packedOrders, setPackedOrders] = useState(false);
  const defaultText = "Generate Picklist";
  const handleFilterClick = (filterTitle) => {
    setActiveFilter(filterTitle);
  };
  const findSyncStatus = async () => {
    try {
      setLoading(true);
      const store_sync_status = await get_store_sync_status();

      const order_sync =
        store_sync_status.data.order_sync === "COMPLETED" ? true : false;
      setSyncStatus(order_sync);
    } catch (err) {
      setSyncStatus(true);
    } finally {
      setLoading(false);
    }
  };

  const [showFilters, setShowFilters] = useState(false);
  const [filters, setFilters] = useState({
    risk: [],
    tags: [],
    notTaggedWith: [],
    deliveryStatus: "",
    financial: "",
    appName: [],
    returnStatus: [],
    channelName: [],
    fulfillmentStatus: "",
    shopifyOrderStatus: [],
  });
  const [fulfilmentOptions, setFulfilmentOptions] = useState([]);
  const [deliveryStatusOptions, setDeliveryStatusOptions] = useState([]);
  const [deliveryMethodOptions, setDeliveryMethodOptions] = useState([]);
  const [financialStatusOptions, setFinancialStatusOptions] = useState([]);
  const [optionsApp, setOptionsApp] = useState([]);
  const [optionsRisk, setOptionsRisk] = useState([]);
  const [optionShopifyStatus, setShopifyStatus] = useState([]);
  const [optionsReturn, setOptionsReturn] = useState([]);

  const [createdAtFromDate, setCreatedAtFromDate] = useState("");
  const [createdAtToDate, setCreatedAtToDate] = useState("");
  const [createdAtFilterValue, setCreatedAtFilterValue] = useState(0);

  const [assignedAtFromDate, setAssignedAtFromDate] = useState("");
  const [assignedAtToDate, setAssignedAtToDate] = useState("");
  const [assignedAtFilterValue, setAssignedAtFilterValue] = useState(0);

  const [checkedItems, setCheckedItems] = useState({});
  const [page, setPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  // const [itemsPerPage, setItemsPerPage] = useState(10);
  const [itemsPerPage, setItemsPerPage] = useState(() => {
    const savedPageSize = localStorage.getItem("itemsPerPage");
    return savedPageSize ? parseInt(savedPageSize, 10) : 10;
  });
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [selectedAdmin, setSelectedAdmin] = useState(null);
  const [filtersReset, setFiltersReset] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [taggedWithSuggestions, setTaggedWithSuggestions] = useState([]);
  const [notTaggedWithSuggestions, setNotTaggedWithSuggestions] = useState([]);
  const [customFieldTrigger, setCustomFieldTrigger] = useState(false);
  const [customFilters, setCustomFilters] = useState([]);
  const [customFilter, setCustomFilter] = useState(null);
  const [showAllFiltersDropdown, setShowAllFiltersDropdown] = useState(false);
  const [activeButton, setActiveButton] = useState(null);
  // Generate Picklist
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [selectOrderVisible, setSelectOrderVisible] = useState(false);
  const [selectedPickListType, setSelectedPickListType] = useState();
  const [orderDetails, setOrdersDetails] = useState();
  const dropdownRef = useRef(null);
  //assign to
  const [assignModalVisible, setAssignModalVisible] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState({});
  const [selectedOrdersValid, setSelectedOrdersValid] = useState(true);
  //CustomToast
  const showToast = CustomToast();
  const { showAlert } = CustomAlert();
  const toggleAllFiltersDropdown = () => {
    setShowFilters(false);
    setShowAllFiltersDropdown((prev) => !prev);
  };
  useEffect(() => {
    fetchCustomFilters();
  }, []);
  const handleItemsPerPageChange = (newPageSize) => {
    setItemsPerPage(newPageSize);
    localStorage.setItem("itemsPerPage", newPageSize.toString());
  };
  const fetchCustomFilters = async () => {
    try {
      const response = await GET_ALL_CUSTOM_FILTERS();
      if (response.data && Array.isArray(response.data)) {
        setCustomFilters(response.data);
      } else {
        console.error("Unexpected data format:", response);
      }
    } catch (error) {
      console.error("Error fetching custom filters:", error);
    }
  };

  const handleSelectFilter = (filterKey) => {
    setCustomFilter(filterKey);
  };

  const handleCustomFieldChange = () => {
    setCustomFieldTrigger((prev) => !prev);
  };
  // const handleSelectFilter = (filterKey) => {
  //   setCustomFilter(filterKey);
  // };

  useEffect(() => {
    findSyncStatus();
    fetchFilterOptions();
  }, []);

  const fetchFilterOptions = async () => {
    try {
      const data = await GET_ORDER_FILTER_OPTIONS_BY_TYPE();

      const mapOptions = (options) =>
        Object.entries(options || {}).map(([key, value]) => ({
          label: key,
          value,
        }));

      const fulfilmentOptions = mapOptions(data?.fulfillmentStatus);
      const deliveryStatusOptions = mapOptions(data?.deliveryStatus);
      const deliveryMethod = mapOptions(data?.deliveryMethod);
      const financialStatusOptions = mapOptions(data?.financialStatus);
      const optionsApp = mapOptions(data?.app);
      const optionsRisk = mapOptions(data?.risk);
      const optionsReturn = mapOptions(data?.returnStatus);
      const shopifyOrderStatus = mapOptions(data?.shopifyOrderStatus);

      setFulfilmentOptions(fulfilmentOptions);
      setDeliveryStatusOptions(deliveryStatusOptions);
      setDeliveryMethodOptions(deliveryMethod);
      setFinancialStatusOptions(financialStatusOptions);
      setOptionsApp(optionsApp);
      setOptionsRisk(optionsRisk);
      setOptionsReturn(optionsReturn);
      setShopifyStatus(shopifyOrderStatus);
    } catch (error) {
      CustomToast.fire({
        icon: "error",
        text: `Failed to fetch filter options:", error`,
      });
      // message.error("Failed to fetch filter options:", error);
    }
  };

  const handleCheckboxChange = (event, newCheckedItems = null, id = null) => {
    if (newCheckedItems) {
      // console.log("Updating all items:", newCheckedItems);
      setCheckedItems(newCheckedItems);
    } else if (id !== null) {
      // console.log("Toggling item:", id);
      setCheckedItems((prev) => {
        const updated = { ...prev, [id]: !prev[id] };
        // console.log("Updated checked items:", updated);
        return updated;
      });
    }
  };

  useEffect(() => {
    // Reset checked items when page or itemsPerPage changes
    setCheckedItems({});
  }, [page, itemsPerPage]);

  const handleDateFilterChange = (selectedValue, fromDate, toDate) => {
    let newFromDate = "";
    let newToDate = "";
    let userSelectedValue = parseInt(selectedValue);

    if (userSelectedValue >= 1 && userSelectedValue <= 5) {
      const newDates = getStartAndEndDate(userSelectedValue);
      newFromDate = newDates.startDate;
      newToDate = newDates.endDate;
    } else if (userSelectedValue === 6) {
      newFromDate = fromDate;
      newToDate = toDate;
    } else {
      const newDates = getStartAndEndDate(0);
      newFromDate = newDates.startDate;
      newToDate = newDates.endDate;
      userSelectedValue = 0;
    }

    setCreatedAtFilterValue(userSelectedValue);
    setCreatedAtFromDate(newFromDate);
    setCreatedAtToDate(newToDate);

    //TODO: change needed here
    setSelectedFilters((prevFilters) => ({
      ...prevFilters,
      selectedCreatedAtFromDate: newFromDate,
      selectedCreatedAtToDate: newToDate,
      selectedCreatedDateFilterValue: selectedValue,
    }));
  };

  const handleAssignedDateFilterChange = (selectedValue, fromDate, toDate) => {
    let newFromDate = "";
    let newToDate = "";
    let userSelectedValue = parseInt(selectedValue);

    if (userSelectedValue >= 1 && userSelectedValue <= 5) {
      const newDates = getStartAndEndDate(userSelectedValue);
      newFromDate = newDates.startDate;
      newToDate = newDates.endDate;
    } else if (userSelectedValue === 6) {
      newFromDate = fromDate;
      newToDate = toDate;
    } else {
      const newDates = getStartAndEndDate(0);
      newFromDate = newDates.startDate;
      newToDate = newDates.endDate;
      userSelectedValue = 0;
    }

    setAssignedAtFilterValue(userSelectedValue);
    setAssignedAtFromDate(newFromDate);
    setAssignedAtToDate(newToDate);
  };

  const updateFilter = (filterName, value) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [filterName]: value,
    }));

    if (filterName === "dateFilter") {
      // setSelectedFilters((prevFilters) => ({
      //   ...prevFilters,
      //   fromDate: valueFilterByFromDate,
      //   toDate: valueFilterByToDate,
      //   dateFilterValue: valueFilterByDate,
      // }));
    } else {
      setSelectedFilters((prevFilters) => ({
        ...prevFilters,
        [filterName]: value,
      }));
    }

    setCustomFieldTrigger((prev) => !prev);
  };

  const handleEmployeeSelect = (employee) => {
    setSelectedEmployee(employee);
  };

  const handleSelectAdmin = (admin) => {
    setSelectedAdmin(admin);
  }
  const handleTaggedWithSearch = async (value) => {
    setLoading(true);
    try {
      const response = await GET_FETCH_TAG_SUGGESTION(value);
      const suggestions = response.data.map((item) => item.tag_name.trim());
      setTaggedWithSuggestions(suggestions);
    } catch (error) {
      CustomToast.fire({
        icon: "error",
        text: `Failed to fetch suggestions for taggedWith:", error`,
      });
      // message.error("Failed to fetch suggestions for taggedWith:", error);
    } finally {
      setLoading(false);
    }
  };

  const debouncedHandleTaggedWithSearch = debounce(handleTaggedWithSearch, 1500)

  const handleNotTaggedWithSearch = async (value) => {
    setLoading(true);
    try {
      const response = await GET_FETCH_TAG_SUGGESTION(value);
      const suggestions = response.data.map((item) => item.tag_name.trim());
      setNotTaggedWithSuggestions(suggestions);
    } catch (error) {
      CustomToast.fire({
        icon: "error",
        text: `Failed to fetch suggestions for notTaggedWith:", ${error}`,
      });
      // message.error("Failed to fetch suggestions for notTaggedWith:", error);
    } finally {
      setLoading(false);
    }
  };

  const debouncedHandleNotTaggedWithSearch = debounce(handleNotTaggedWithSearch, 1500)
  const resetFilters = () => {
    setFilters({
      risk: [],
      tags: [],
      notTaggedWith: [],
      delivery: "",
      deliveryMethod: "",
      financial: "",
      appName: [],
      returnStatus: [],
      channelName: [],
      shopifyOrderStatus: [],
      fulfillmentStatus: "",
    });
    setCreatedAtFilterValue(0);
    setCreatedAtFromDate("");
    setCreatedAtToDate("");
    setAssignedAtFilterValue(0);
    setAssignedAtFromDate("");
    setAssignedAtToDate("");
    setCustomFilter("");
    setSelectedEmployee(null);
    setSelectedAdmin(null);
    setCheckedItems({});
    setFiltersReset(true);
    setSelectedEmployee("");
    setSelectedAdmin("");
    setSearch("");
    setActiveFilterId(null);
    setActiveFilter(null);
    setAppliedFilters({});
    setSelectedFilters({});
    setReturnedOrders(false)
    setIsReturnActive(false)
    setPackedOrders(false)

  };
  const filterConfigs = [
    {
      title: "Order Date",
      type: "date",
      isDateFilter: true,
      valueFilterByDate: createdAtFilterValue,
      onDateFilterChange: handleDateFilterChange,
    },
    {
      title: "Assigned Date",
      type: "date",
      isDateFilter: true,
      valueFilterByDate: assignedAtFilterValue,
      onDateFilterChange: handleAssignedDateFilterChange,
    },
    {
      title: "Fulfillment Status",
      type: "radio",
      values: fulfilmentOptions,
      onChange: (value) => updateFilter("fulfillmentStatus", value),
      isTagFilter: false,
    },
    {
      title: "Tagged With",
      type: "select",
      onChange: (value) => updateFilter("tags", value),
      onSearch: debouncedHandleTaggedWithSearch,
      suggestions: taggedWithSuggestions,
      isTagFilter: true,
    },
    {
      title: "Not Tagged With",
      type: "select",
      onChange: (value) => updateFilter("notTaggedWith", value),
      onSearch: debouncedHandleNotTaggedWithSearch,
      suggestions: notTaggedWithSuggestions,
      isTagFilter: true,
    },
    {
      title: "Delivery Status",
      type: "radio",
      values: deliveryStatusOptions,
      onChange: (value) => updateFilter("deliveryStatus", value),
      isTagFilter: false,
    },
    {
      title: "Delivery Method",
      type: "radio",
      values: deliveryMethodOptions,
      onChange: (value) => updateFilter("deliveryMethod", value),
      isTagFilter: false,
    },
    {
      title: "Financial Status",
      type: "radio",
      values: financialStatusOptions,
      onChange: (value) => updateFilter("financial", value),
      isTagFilter: false,
    },
    {
      title: "App",
      type: "select",
      values: optionsApp,
      onChange: (value) => updateFilter("appName", value),
      isTagFilter: false,
    },
    {
      title: "Return",
      type: "select",
      values: optionsReturn,
      onChange: (value) => updateFilter("returnStatus", value),
      isTagFilter: false,
    },
    {
      title: "Channel",
      type: "select",
      values: optionsApp,
      onChange: (value) => updateFilter("channelName", value),
      isTagFilter: false,
    },
    {
      title: "Risk Level",
      type: "select",
      values: optionsRisk,
      onChange: (value) => updateFilter("risk", value),
      isTagFilter: false,
    },
    {
      title: "Order Status",
      type: "select",
      values: optionShopifyStatus,
      onChange: (value) => updateFilter("shopifyOrderStatus", value),
      isTagFilter: false,
    },
  ];

  const generatePicklist = [
    {
      id: "order",
      title: "By Order",
      module: "diMGeD",
      permission: "wwkpjt",
    },
    {
      id: "product",
      title: "By Product",
      module: "diMGeD",
      permission: "To6Daz",
    },
  ];

  const toggleFilters = () => {
    setShowAllFiltersDropdown(false);
    setShowFilters((prevState) => !prevState);
    setActiveButton("filter");
  };

  const handleSearchIconClick = () => {
    setSearchVisible(true);
    setIconVisible(false);
    setActiveButton("search");
  };

  const handleCancelButtonClick = () => {
    setSearchVisible(false);
    setIconVisible(true);
    setSearch("");
  };

  const handleValidateSelection = (validation) => {
    setSelectedOrdersValid(validation.isValid);
  };

  const handleButtonClick = async () => {
    const ids = Object.keys(checkedItems)
      .filter((id) => checkedItems[id])
      .map((id) => Number(id));

    try {
      if (ids.length > 0) {
        if (!selectedOrdersValid) {
          await showAlert(
            "Warning",
            "Please select only assigned orders to unassign.",
            "warning",
            "Okay",
            undefined,
            null,
            false,
            true,
            false
          );
          return;
        }

        await SEND_SELECTED_EMPLOYEE_ID(ids);
        showToast("Successfully unassigned orders.", "success");
        updateFilter();
      } else {
        await showAlert(
          "Warning",
          "Please select one or multiple orders.",
          "warning",
          "Okay",
          undefined,
          null,
          false,
          true,
          false
        );
      }
    } catch (error) {
      showToast("Failed to unassign orders.", "error");
    }
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleDropdown = () => setIsOpen(!isOpen);
  const fetchOrderDetails = async () => {
    try {
      if (checkedItems) {
        const checkedIds = Object.keys(checkedItems).filter(
          (id) => checkedItems[id]
        );
        const response = await order_details(checkedIds);
        const result = response.data.data.map((item) => item.name).join(", ");
        setOrdersDetails(result);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleOptionSelect = (option) => {
    const selectedItems = Object.keys(checkedItems).filter(
      (id) => checkedItems[id]
    );
    if (selectedItems.length === 0) {
      showAlert(
        "Warning",
        "Please select one or multiple orders.",
        "warning",
        "Okay",
        undefined,
        null,
        false,
        true,
        false
      ).then(() => {
        return;
      });
      return;
    }

    const selectedPicklistOption = generatePicklist.find(
      (item) => item.title === option
    );
    if (selectedPicklistOption) {
      setSelectOrderVisible(true);
      fetchOrderDetails();
      setSelectedPickListType(selectedPicklistOption.id);
    }
  };
  const handleAssignToClick = () => {
    const selectedItems = Object.keys(checkedItems).filter(
      (id) => checkedItems[id]
    );
    if (selectedItems.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "No Orders Selected",
        text: "Please select one or multiple orders.",
      });
    } else {
      setAssignModalVisible(true);
    }
  };

  const handleSaveAs = () => {
    setIsNewFilterModalOpen(true);
  };
  const handlePrintClick = () => {
    const selectedItems = Object.keys(checkedItems).filter(
      (id) => checkedItems[id]
    );
    if (selectedItems.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "No Orders Selected",
        text: "Please select one or multiple orders to print.",
      });
    } else {
      const selectedIds = selectedItems.map(id => Number(id));
      navigate("/packingslip", {
        state: {
          ids: selectedIds
        }
      });
    }
  };

  const handleReturnOrdersClick = () => {
    setReturnedOrders(prev => !prev);
    setIsReturnActive(!isReturnActive);
  };

  const handlePackedOrdersClick = ()=>{
    setPackedOrders(prev => !prev);
  }

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  const handleDownloadAll = async () => {
    const selectedItems = Object.keys(checkedItems).filter(
      (id) => checkedItems[id]
    );
    
    if (selectedItems.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "No Orders Selected",
        text: "Please select one or multiple orders to export.",
      });
      return;
    }  
    try {
      setIsLoading(true);
      const selectedIds = selectedItems.map(id => Number(id));
      await EXPORT_MULTIPLE_ORDER_MEDIA(selectedIds);
      
      showToast("Your export file has been sent to your email.", "success");
    } catch (error) {
      if (error.isAxiosError && error.response) {
        if (error.response.status === 400) {
          const errorMessage = error.response.data?.err || "Bad request";
          showToast(`${errorMessage}`, "error");
          return;
        }
        if (error.response.status === 500) {
          const errorMessage = error.response.data?.err || "Server error occurred";
          showToast(errorMessage, "error");
          return;
        }
      }
      showToast("Failed to export orders. Please try again later.", "error");
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <>
      {loading && <Loader className={styles.loader} />}

      <div className={styles.card}>
        {!syncStatus ? (
          <>
            <Card className={styles.card}>
              <div className="mb-[2%] w-full flex flex-col justify-center items-center">
                <p>
                  We're syncing your store data. Please refresh the page in a few
                  moments.
                </p>
                <div className="mt-[10px]">
                  <button className={cn("button")} onClick={() => findSyncStatus()}>
                    Refresh
                  </button>
                </div>
              </div>
            </Card>
          </>
        ) : (
          <>
            <Card className={styles.card}>
              <div className="flex justify-between items-center  mb-12">
                <div className={cn("title-purple", styles.subtitle)}>
                  View Order
                </div>
                <div className="flex items-center space-x-2">
                  <button
                    className={cn(
                      "button-clear-stroke button-clear-stroke-red button-small",
                      styles.button
                    )}
                    onClick={resetFilters}
                  >
                    <Icon name="clearAll" size="24" /> Clear All Filters
                  </button>
                  <AccessControl moduleCode="eV79MY" requiredPrivilege="xPGbZk">
                    <button
                      className={cn("button-stroke button-small")}
                      onClick={handleAssignToClick}
                    >
                      Assign To
                    </button>
                  </AccessControl>
                  <button
                    className={cn("button-stroke button-small", styles.button)}
                    onClick={handleDownloadAll }
                  >
                    <span>Download All</span>
                  </button>
                  <AccessControl
                    moduleCode="diMGeD"
                    requiredPrivilege="mrbNPj" >
                    <button
                      className={cn("button-stroke button-small")}
                      onClick={handlePrintClick}
                    >
                      Print Packing Slip
                    </button>
                  </AccessControl>
                  <AccessControl
                    moduleCodes="eV79MY"
                    requiredPrivileges="xPGbZk"
                  >
                    <button
                      className={cn("button-stroke button-small")}
                      onClick={handleButtonClick}
                    >
                      Unassign
                    </button>
                  </AccessControl>
                  <MultiAccessControl
                    moduleCodes={["diMGeD"]}
                    requiredPrivileges={["wwkpjt", "To6Daz"]}
                  >
                    <Dropdown
                      className="generate-picklist-dropdown"
                      classDropdownHead="generate-picklist-head"
                      value={defaultText}
                      setValue={(option) => {
                        handleOptionSelect(option);
                      }}
                      options={generatePicklist.map((item) => (
                        <AccessControl
                          key={item.id}
                          moduleCode={item.module}
                          requiredPrivilege={item.permission}
                        >
                          <span
                            onClick={() => handleOptionSelect(item.title)}
                            className="cursor-pointer"
                          >
                            {item.title}
                          </span>
                        </AccessControl>
                      ))}
                      small
                    />
                  </MultiAccessControl>
                </div>
              </div>

              <AssignToPickerOrPacker
                assignvisibleModal={assignModalVisible}
                setAssignVisibleModal={setAssignModalVisible}
                checkedItems={checkedItems}
                updateFilter={updateFilter}
                handleCheckboxChange={handleCheckboxChange}
              />

              <GeneratePickListPopUp
                visible={selectOrderVisible}
                setVisible={setSelectOrderVisible}
                checkedItems={checkedItems}
                updateFilter={updateFilter}
                handleCheckboxChange={handleCheckboxChange}
                selectedPickListType={selectedPickListType}
                orderDetails={orderDetails}
              />

              <div className="flex gap-4 sm:flex-col sm:gap-2 md:flex-col md:gap-2  w-full">
                {searchVisible && (
                  <div className="w-[100%] flex">
                    <Form
                      className={cn(
                        styles.form,
                        "w-[100%]",
                        " sm:w-full",
                        "md:w-[100%]",
                        "lg:w-[100%]",
                        "xl:w-[100%]"
                      )}
                      value={search}
                      setValue={setSearch}
                      onSubmit={handleSubmit}
                      placeholder="Search By Order Number"
                      type="text"
                      name="search"
                      icon="search"
                      autoFocus={true}
                    />
                    <button
                      className={cn(
                        "button-stroke button-small",
                        styles.button,
                        "ml-[2%] mr-[1%]",
                        "whitespace-nowrap px-2.5 py-2 text-[13px]"
                      )}
                      onClick={handleCancelButtonClick}
                    >
                      Cancel
                    </button>
                  </div>
                )}

                {iconVisible && (
                  <div
                    className={
                      "flex items-center gap-4 sm:flex-col sm:gap-2 md:flex-col md:gap-2 w-full"
                    }
                  >
                    <div>
                      <AllFiltersDropdown
                        customFilters={customFilters}
                        onSelectFilter={handleSelectFilter}
                        setCustomFilters={setCustomFilters}
                        onSelect={handleEmployeeSelect}
                        onAdminSelect={handleSelectAdmin}
                        checkedItems={checkedItems}
                        updateFilter={updateFilter}
                        handleCheckboxChange={handleCheckboxChange}
                        filtersReset={filtersReset}
                        setFiltersReset={setFiltersReset}
                        activeFilterId={activeFilterId}
                        setActiveFilterId={setActiveFilterId}
                        selectedFilters={selectedFilters}
                        isNewFilterModalOpen={isNewFilterModalOpen}
                        setIsNewFilterModalOpen={setIsNewFilterModalOpen}
                      />
                    </div>
                  </div>
                )}
                <div className="flex gap-[25px]">
                  {iconVisible && (
                    <div
                      className={cn(
                        "flex border-2 border-[#F4F4F4] p-[5px_9px] h-[38px] rounded-[8px]",
                        styles.filtericon
                      )}
                    >
                      <Tooltip title="Search">
                        <button
                          className={cn(styles.link, {
                            [styles.active]: activeButton === "search",
                          })}
                          onClick={handleSearchIconClick}
                        >
                          <Icon name="search" size="24" />
                        </button>
                      </Tooltip>
                      <Tooltip title="Filters">
                        <button
                          className={cn(styles.link, {
                            [styles.active]: activeButton === "filter",
                          })}
                          onClick={toggleFilters}
                        >
                          <Icon name="customizingorder" size="24" />
                        </button>
                      </Tooltip>
                    </div>
                  )}
                  <AccessControl
                    moduleCode="diMGeD"
                    requiredPrivilege="5LZR2A">
                    <div
                      className={cn(
                        "flex border-2 border-[#F4F4F4] p-[5px_9px] h-[38px] rounded-[8px]",
                        styles.filtericon
                      )}>
                      <Export
                        activeButton={activeButton}
                        setActiveButton={setActiveButton}
                        toggleFilters={toggleFilters}
                        checkedItems={checkedItems}
                        handleCheckboxChange={handleCheckboxChange}
                        page={page}
                        setPage={setPage}
                        totalItems={totalItems}
                        setTotalItems={setTotalItems}
                        search={search}
                        {...filters}
                        createdAtFromDate={createdAtFromDate}
                        createdAtToDate={createdAtToDate}
                        assignedAtFromDate={assignedAtFromDate}
                        assignedAtToDate={assignedAtToDate}
                        itemsPerPage={itemsPerPage}
                        selectedEmployee={selectedEmployee}
                        selectedAdmin={selectedAdmin}
                        customFilters={customFilter}
                        returnedOrders={returnedOrders}
                        packedOrders={packedOrders}
                      />
                    </div>
                  </AccessControl>
                  <div
                    className={cn(
                      "flex border-2 border-[#F4F4F4] p-[5px_9px] h-[38px] rounded-[8px]",
                      styles.filtericon
                    )}
                  >
                    <CustomizingOrderFields
                      onCustomFieldChange={handleCustomFieldChange}
                      activeButton={activeButton}
                      setActiveButton={setActiveButton}
                    />
                  </div>
                </div>
              </div>

              {showFilters && (
                <>
                  <Divider />
                  <div className={"w-[100%] flex justify-between gap-1"}>
                    <div>
                      <Filter
                        filterConfigs={filterConfigs}
                        activeFilter={activeFilter}
                        handleFilterClick={handleFilterClick}
                        setAppliedFilters={setAppliedFilters}
                        appliedFilters={appliedFilters}
                        handleReturnOrdersClick={handleReturnOrdersClick}
                        handlePackedOrdersClick={handlePackedOrdersClick}
                        isPackedOrdersActive = {packedOrders}
                        isReturnActive={isReturnActive}
                        filtersReset={filtersReset}
                        setFiltersReset={setFiltersReset}
                        activeFilterId={activeFilterId}
                        setActiveFilterId={setActiveFilterId}
                        selectedFilters={selectedFilters}
                        onSelect={handleEmployeeSelect}
                        onAdminSelect={handleSelectAdmin}
                      />
                    </div>
                    <div
                      onClick={handleSaveAs}
                      className={cn("button-small", styles.button)}
                      to="/products/add"
                    >
                      <Icon name="save" size="24" />
                      <span>Save</span>
                    </div>
                  </div>
                </>
              )}

              {showAllFiltersDropdown && activeIndex === 0 && (
                <div className={cn("w-[100%] flex gap-[5px] flex-wrap")}>
                  <AllFiltersDropdown
                    customFilters={customFilters}
                    onSelectFilter={handleSelectFilter}
                    setCustomFilters={setCustomFilters}
                  />
                </div>
              )}
            </Card>
            <div className={cn(styles.wrapper)}>
              <OrdersTable
                search={search}
                {...filters}
                createdAtFromDate={createdAtFromDate}
                createdAtToDate={createdAtToDate}
                assignedAtFromDate={assignedAtFromDate}
                assignedAtToDate={assignedAtToDate}
                checkedItems={checkedItems}
                handleCheckboxChange={handleCheckboxChange}
                page={page}
                setPage={setPage}
                totalItems={totalItems}
                itemsPerPage={itemsPerPage}
                setItemsPerPage={handleItemsPerPageChange}
                setTotalItems={setTotalItems}
                selectedEmployee={selectedEmployee}
                selectedAdmin={selectedAdmin}
                customFilters={customFilter}
                customFieldTrigger={customFieldTrigger}
                returnedOrders={returnedOrders}
                packedOrders = {packedOrders}
                setSearch={setSearch}
                onValidateSelection={handleValidateSelection}
                setIsLoading={setIsLoading}
              />
            </div>
            <LoaderOverlay loading={isLoading} />
          </>
        )}
      </div>
    </>
  );
};

export default AllOrders;
